// Define process before any imports
window.process = window.process || {
  env: {
    NODE_ENV: process.env.NODE_ENV || 'development'
  }
};
import './axiosConfig';
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import Loadable from "react-loadable";
import { BrowserRouter } from "react-router-dom";
import createStore from "./store";
import App from "./app/App";
import NotificationManager from "app/components/organisms/NotificationManager/NotificationManager";

// Polyfill for useSyncExternalStore
if (!React.useSyncExternalStore) {
  React.useSyncExternalStore = function(subscribe, getSnapshot) {
    const [state, setState] = React.useState(getSnapshot());
    
    React.useEffect(() => {
      const unsubscribe = subscribe(() => {
        setState(getSnapshot());
      });
      
      return unsubscribe;
    }, [subscribe, getSnapshot]);
    
    return state;
  };
}

// Create a store and get back itself
const { store } = createStore();

// Running locally, we should run on a <BrowserRouter />
const Application = (
  <Provider store={store}>
    <BrowserRouter>
        <App />
    </BrowserRouter>
  </Provider>
);

const rootElement = document.querySelector("#root");

// If we're not running on the server, just render like normal
Loadable.preloadReady().then(() => {
  ReactDOM.render(Application, rootElement);
});